/** Static lists
 * (title) and (name) are required
 * (param) is required if it's used in filters
 * (name) is the value for the list item
 */
class Lists {
  constructor() {
    "ngInject";

    const renewalValues = [
      { title: "OFF", name: "off" },
      { title: "Daily", name: "day" },
      { title: "Weekly", name: "isoWeek" },
      { title: "Monthly", name: "month" },
      { title: "Quarterly", name: "quarter" },
      { title: "Yearly", name: "year" },
    ];

    const distanceTypes = [
      { title: "Ride", name: "ride", param: "distance_type" },
      { title: "Hexes", name: "hexes", param: "distance_type" },
    ];
    const scheduleLabels = [
      { title: "Ramadan", name: "ramadan", param: "label" },
      { title: "Normal", name: "normal", param: "label" },
      { title: "Experiment 1", name: "Experiment 1", param: "label" },
    ];
    const scheduleLabelsWithNone = [
      { title: "All", name: "", param: "label" },
      { title: "Ramadan", name: "ramadan", param: "label" },
      { title: "Normal", name: "normal", param: "label" },
      { title: "Experiment 1", name: "Experiment 1", param: "label" },
    ];
    const initialRenewalValues = [
      { title: "Daily", name: "day" },
      { title: "Weekly", name: "isoWeek" },
      { title: "Monthly", name: "month" },
      { title: "Quarterly", name: "quarter" },
      { title: "Yearly", name: "year" },
    ];

    const bookingStatus = [
      { title: "Booked", name: "booked", param: "status" },
      { title: "Checked In", name: "checked_in", param: "status" },
      { title: "Missed", name: "missed", param: "status" },
      { title: "Completed", name: "completed", param: "status" },
      { title: "Cancelled", name: "cancelled", param: "status" },
      { title: "Transferred", name: "transferred", param: "status" },
      { title: "Delayed", name: "delayed", param: "status" },
      { title: "Pending", name: "pending", param: "status" },
    ];

    const cashCollectionStatus = [
      { title: "Pending", name: "pending", param: "cash_collection_status" },
      { title: "Resolved", name: "resolved", param: "cash_collection_status" },
    ];

    const dailyReportKeys = [
      { title: "Cancelled rides count", name: "cancelled_rides_count" },
      { title: "Late rides count", name: "late_rides_count" },
      { title: "Late users count", name: "late_users_count" },
      { title: "Backup rides count", name: "backup_rides_count" },
      { title: "Topups count", name: "topup_count" },
      { title: "Topups amount", name: "topup_amount" },
      { title: "Low ratings count", name: "low_rating_count" },
    ];

    const active = [
      { title: "Any", name: null, param: "active" },
      { title: "True", name: "true", param: "active" },
      { title: "False", name: "false", param: "active" },
    ];

    const generateReportTypes = [
      { title: "Detailed Delays", name: "detailed_delays" },
      { title: "Summary Delays", name: "summary_delays" },
      { title: "Detailed Ratings", name: "detailed_ratings" },
      { title: "Summary Ratings", name: "summary_ratings" },
      {
        title: "Schedules Financial Plan",
        name: "captain_plan_validation_report",
      },
      { title: "Detailed Supply Finances", name: "detailed_captain_finances" },
      { title: "Summary Supply Finances", name: "summary_captain_finances" },
      { title: "Captain Forced Enabled GPS", name: "captain_gps_force_enable" },
    ];

    const arrivedFirstStation = [
      { title: "Any", name: null, param: "arrived_first_station" },
      { title: "True", name: "true", param: "arrived_first_station" },
      { title: "False", name: "false", param: "arrived_first_station" },
    ];

    const hasBookings = [
      { title: "Any", name: null, param: "has_bookings" },
      { title: "True", name: "true", param: "has_bookings" },
      { title: "False", name: "false", param: "has_bookings" },
    ];

    const unassignedCaptain = [
      { title: "Any", name: null, param: "captain_assigned" },
      { title: "True", name: "true", param: "captain_assigned" },
      { title: "False", name: "false", param: "captain_assigned" },
    ];

    const unassignedVendor = [
      { title: "Any", name: null, param: "is_vendor_assigned" },
      { title: "True", name: "true", param: "is_vendor_assigned" },
      { title: "False", name: "false", param: "is_vendor_assigned" },
    ];

    const corpRoles = [
      { title: "No Role", name: null, param: "corp_role" },
      { title: "Admin", name: "admin", param: "corp_role" },
      { title: "Employee", name: "employee", param: "corp_role" },
    ];

    const dispatch = [
      { title: "Any", name: null, param: "dispatch" },
      { title: "True", name: "true", param: "dispatch" },
      { title: "False", name: "false", param: "dispatch" },
    ];

    const tier = [
      { title: "Any", name: null, param: "tier" },
      { title: "Basic", name: "basic", param: "tier" },
      { title: "Bronze", name: "bronze", param: "tier" },
      { title: "Silver", name: "silver", param: "tier" },
      { title: "Gold", name: "gold", param: "tier" },
      { title: "Swvl", name: "swvl", param: "tier" },
    ];

    const captainStatus = [
      { title: "Active", name: "active", param: "status" },
      { title: "Applied", name: "applied", param: "status" },
      { title: "Inactive", name: "inactive", param: "status" },
      { title: "Onboarded", name: "onboarded", param: "status" },
      { title: "Terminated", name: "terminated", param: "status" },
    ];

    const rideStatus = [
      { title: "Scheduled", name: "scheduled", param: "status" },
      { title: "Started", name: "started", param: "status" },
      { title: "Stopped", name: "stopped", param: "status" },
      { title: "Completed", name: "completed", param: "status" },
      { title: "Cancelled", name: "cancelled", param: "status" },
      {
        title: "Arrived First Station",
        name: "arrived_first_station",
        param: "status",
      },
      {
        title: "Corporate Revised",
        name: "corporate_revised",
        param: "status",
      },
    ];

    const backupStatus = [
      { title: "Scheduled", name: "scheduled", param: "status" },
      { title: "Started", name: "started", param: "status" },
      { title: "Stopped", name: "stopped", param: "status" },
      { title: "Busy", name: "busy", param: "status" },
      { title: "Completed", name: "completed", param: "status" },
      { title: "Cancelled", name: "cancelled", param: "status" },
    ];

    const backupStationStatus = [
      {
        title: "Not Arrived",
        name: "not_arrived",
        param: "backup_station_status",
      },
      { title: "Arrived", name: "arrived", param: "backup_station_status" },
      {
        title: "Away from Station",
        name: "away_from_station",
        param: "backup_station_status",
      },
    ];

    const shiftStatus = [
      { title: "All", name: null, param: "status" },
      { title: "Active", name: "active", param: "status" },
      { title: "Inactive", name: "in-active", param: "status" },
      { title: "Completed", name: "completed", param: "status" },
    ];

    const payments = [
      { title: "Any", name: null, param: "payment" },
      { title: "Cash", name: "cash", param: "payment" },
      { title: "Credit Card", name: "card", param: "payment" },
      { title: "M-PESA", name: "m_pesa", param: "payment" },
    ];

    const captainPayments = [
      { title: "Cash", name: "cash" },
      { title: "Supplier", name: "supplier" },
      { title: "Dopay", name: "dopay" },
    ];

    const captainLoans = [
      { title: "Cash", name: "cash" },
      { title: "Mobile", name: "mobile" },
    ];

    const states = [
      { name: "booking", state: "booking" },
      { name: "user", state: "customer" },
      { name: "bus_type", state: "bustype" },
      { name: "station", state: "station" },
      { name: "route", state: "route" },
      { name: "promotion", state: "promotion" },
      { name: "bus", state: "bus" },
      { name: "district", state: "district" },
      { name: "city", state: "city" },
      { name: "corporate", state: "corporate" },
      { name: "company", state: "company" },
      { name: "captain", state: "captain" },
      { name: "ride", state: "ride" },
    ];

    const weekDays = [
      { value: 6, shortName: "Sat", fullName: "Saturday", isSelected: false },
      { value: 7, shortName: "Sun", fullName: "Sunday", isSelected: false },
      { value: 1, shortName: "Mon", fullName: "Monday", isSelected: false },
      { value: 2, shortName: "Tue", fullName: "Tuesday", isSelected: false },
      { value: 3, shortName: "Wed", fullName: "Wednesday", isSelected: false },
      { value: 4, shortName: "Thu", fullName: "Thursday", isSelected: false },
      { value: 5, shortName: "Fri", fullName: "Friday", isSelected: false },
    ];

    const planWeekDays = [
      { value: "saturday", shortName: "Sat", fullName: "Saturday" },
      { value: "sunday", shortName: "Sun", fullName: "Sunday" },
      { value: "monday", shortName: "Mon", fullName: "Monday" },
      { value: "tuesday", shortName: "Tue", fullName: "Tuesday" },
      { value: "wednesday", shortName: "Wed", fullName: "Wednesday" },
      { value: "thursday", shortName: "Thu", fullName: "Thursday" },
      { value: "friday", shortName: "Fri", fullName: "Friday" },
    ];

    const dayOptions = [
      { name: "available", title: "Available", isSelected: true },
      { name: "vacation", title: "Vacation" },
      { name: "backup", title: "Backup" },
    ];

    const ticketTitles = [
      { name: "Booking Id", title: "Booking" },
      { name: "User", title: "Customer" },
      { name: "User Phone", title: "Customer Phone" },
    ];

    const reportTypes = [
      {
        name: "captainRating",
        title: "Captain Rating Report",
        state: "captain",
      },
      { name: "dailyReport", title: "Daily Report", state: "ride" },
    ];

    const paymentOptions = [{ title: "Cash", value: "cash" }];

    const invoiceStatus = [
      { title: "Any", name: null, param: "status" },
      { title: "In progress", name: "in_progress", param: "status" },
      { title: "Pending", name: "pending", param: "status" },
      { title: "Final", name: "final", param: "status" },
    ];

    const invoicePaid = [
      { title: "Any", name: null, param: "paid" },
      { title: "True", name: "true", param: "paid" },
      { title: "False", name: "false", param: "paid" },
    ];

    const cancellationRulesTimeOptions = [
      { title: "After", value: 1 },
      { title: "Before", value: -1 },
    ];

    const cancellationRulesAnchorOptions = [
      { title: "Booking Time", value: "booking.date" },
      { title: "Pickup Time", value: "booking.pick_up_time" },
    ];

    const rideTypes = [
      { title: "Regular", name: "regular", param: "type" },
      { title: "Event", name: "event", param: "type" },
      { title: "Travel", name: "travel", param: "type" },
      { title: "Business", name: "business", param: "type" },
      { title: "Custom", name: "custom", param: "type" },
      { title: "Training", name: "training", param: "type" },
    ];

    const supportedRideTypes = [
      {
        title: "Regular",
        name: "regular",
        param: "supported_ride",
        disabled: false,
      },
      {
        title: "Travel",
        name: "travel",
        param: "supported_ride",
        disabled: false,
      },
      {
        title: "Event",
        name: "event",
        param: "supported_ride",
        disabled: true,
      },
      {
        title: "Business",
        name: "business",
        param: "supported_ride",
        disabled: true,
      },
      {
        title: "Custom",
        name: "custom",
        param: "supported_ride",
        disabled: true,
      },
      {
        title: "Training",
        name: "training",
        param: "supported_ride",
        disabled: true,
      },
    ];
    const supportedPackageTypes = [
      { title: "Custom", name: "custom", param: "package_type" },
      { title: "Standard", name: "standard", param: "package_type" },
    ];

    const promoSegments = [
      { title: "Corporate", name: "corporate", param: "segment" },
      {
        title: "Business development",
        name: "business_development",
        param: "segment",
      },
      { title: "Retention", name: "retention", param: "segment" },
      { title: "Activation", name: "activation", param: "segment" },
      { title: "Marketing", name: "marketing", param: "segment" },
    ];

    const stationsHeatmapTime = [
      { title: "AM", name: "am", type: "time" },
      { title: "PM", name: "pm", type: "time" },
    ];

    const stationsHeatmapLocation = [
      { title: "Pickup", name: "pickup", type: "location" },
      { title: "Dropoff", name: "dropoff", type: "location" },
    ];

    const eventStationsTypes = [
      { name: "Pickup", value: "pickup" },
      { name: "Dropoff", value: "dropoff" },
      { name: "Both", value: "both" },
    ];

    const stationsHeatmapSource = [
      { title: "Search", name: "search", type: "source" },
      { title: "Booking", name: "booking", type: "source" },
    ];

    const stationsHeatmapDemand = [
      { title: "Search", name: "search", type: "demand" },
      { title: "Booking", name: "booking", type: "demand" },
    ];

    const routeSatisfictionTypes = [
      { title: "Satisfied", name: "SAT", type: "type" },
      { title: "Unsatisfied", name: "UNSAT", type: "type" },
    ];

    const routeTimingTypes = [
      { title: "AM", name: "AM", type: "time" },
      { title: "PM", name: "PM", type: "time" },
    ];

    const routeType = [
      { title: "True", name: "Dynamic", param: "route_type" },
      { title: "False", name: "Fixed", param: "route_type" },
    ];
    const rideType = [
      { title: "True", name: "true", param: "is_dynamic" },
      { title: "False", name: "false", param: "is_dynamic" },
    ];
    const resolvedTravelRequest = [
      { title: "Any", name: null, param: "resolved" },
      { title: "False", name: "false", param: "resolved" },
      { title: "True", name: "true", param: "resolved" },
    ];

    const fromTravelCities = [
      { title: "Cairo", name: "Cairo", param: "from" },
      { title: "Alexandria", name: "Alexandria", param: "from" },
      { title: "Dahab", name: "Dahab", param: "from" },
      { title: "Hurghada", name: "Hurghada", param: "from" },
      { title: "Sharm El Sheikh", name: "Sharm El Sheikh", param: "from" },
      { title: "North Coast", name: "North Coast", param: "from" },
      { title: "Ras Sedr", name: "Ras Sedr", param: "from" },
      { title: "Ain Sokhna", name: "Ain Sokhna", param: "from" },
    ];
    const toTravelCities = [
      { title: "Cairo", name: "Cairo", param: "to" },
      { title: "Alexandria", name: "Alexandria", param: "to" },
      { title: "Dahab", name: "Dahab", param: "to" },
      { title: "Hurghada", name: "Hurghada", param: "to" },
      { title: "Sharm El Sheikh", name: "Sharm El Sheikh", param: "to" },
      { title: "North Coast", name: "North Coast", param: "to" },
      { title: "Ras Sedr", name: "Ras Sedr", param: "to" },
      { title: "Ain Sokhna", name: "Ain Sokhna", param: "to" },
    ];
    const privateBusStatus = [
      { title: "Cancelled", name: "cancelled", param: "status" },
      { title: "Completed", name: "completed", param: "status" },
      { title: "Pending Payment", name: "pending_payment", param: "status" },
      {
        title: "Pending Operations",
        name: "pending_operations",
        param: "status",
      },
      { title: "Rejected", name: "unsatisfiable", param: "status" },
    ];
    const isRoundTrip = [
      { title: "Any", name: null, param: "is_round_trip" },
      { title: "False", name: "false", param: "is_round_trip" },
      { title: "True", name: "true", param: "is_round_trip" },
    ];
    const roundingOffList = [
      { title: "0.01", value: 0.01 },
      { title: "0.1", value: 0.1 },
      { title: "1", value: 1 },
      { title: "5", value: 5 },
      { title: "10", value: 10 },
      { title: "100", value: 100 },
      { title: "1000", value: 1000 },
    ];
    const isPrivateBusReq = [
      { title: "Any", name: null, param: "private_bus_request" },
      { title: "False", name: "false", param: "private_bus_request" },
      { title: "True", name: "true", param: "private_bus_request" },
    ];

    const packageDiscountTypes = [
      { title: "Flat Fee", name: "flat_fee" },
      { title: "Percentage", name: "percentage" },
    ];

    const bulkBonusesCategories = [
      { title: "Performance Bonus", name: "performance_bonus" },
    ];

    const bulkScriptsCategories = [
      { title: "Create Schedules", name: "create_schedules" },
      { title: "Deactivate Schedules", name: "deactivate_schedules" },
      { title: "Cancel Rides", name: "cancel_rides" },
      { title: "Assign Ride Captain/Bustype", name: "assign_captains" },
      { title: "Assign Users to Schedules", name: "assign_users_to_schedules" },
      {
        title: "Bulk Upload Promos",
        name: "create_promotions_for_multiple_prefixes",
      },
    ];

    const corporateInvoiceItemType = [
      { title: "Business Ride", name: "ride_business", param: "type" },
      { title: "Ride SWVL Penalty", name: "ride_penalty", param: "type" },
      { title: "Cash Settlement", name: "cash_settlement", param: "type" },
      {
        title: "Gas Variance Charge",
        name: "gas_variance_charge",
        param: "type",
      },
      {
        title: "Extra Kilometers Charge",
        name: "extra_kilometers_charge",
        param: "type",
      },
      { title: "Extra Time Charge", name: "extra_time_charge", param: "type" },
      {
        title: "Late Communication Charge",
        name: "late_communication_charge",
        param: "type",
      },
      {
        title: "Late Payment Charge",
        name: "late_payment_charge",
        param: "type",
      },
      { title: "Promotion Billing", name: "promotion_billing", param: "type" },
      { title: "Other Charge", name: "other_charge", param: "type" },
      {
        title: "Gas Variance Penalty",
        name: "gas_variance_penalty",
        param: "type",
      },
      {
        title: "Alternative Transport Compensation Penalty",
        name: "alternative_transport_compensation_penalty",
        param: "type",
      },
      {
        title: "Captain Attitude Penalty",
        name: "captain_attitude_penalty",
        param: "type",
      },
      { title: "No Show Penalty", name: "no_show_penalty", param: "type" },
      {
        title: "Different Vehicle Penalty",
        name: "different_vehicle_penalty",
        param: "type",
      },
      {
        title: "Different Captain Penalty",
        name: "different_captain_penalty",
        param: "type",
      },
      {
        title: "Different Route Penalty",
        name: "different_route_penalty",
        param: "type",
      },
      { title: "Other Penalty", name: "other_penalty", param: "type" },
      {
        title: "Out of contract special request",
        name: "out_of_contract_special_request",
        param: "type",
      },
    ];

    const packageUserSubscribed = [
      { title: "All", name: null, param: "subscribed" },
      { title: "Yes", name: "true", param: "subscribed" },
      { title: "No", name: "false", param: "subscribed" },
    ];

    const currencyList = [
      { name: "EGP", title: "Egyptian pounds", decimal: "millimes" },
      { name: "KES", title: "Kenyan shillings", decimal: "cents" },
      { name: "PKR", title: "Pakistani rupees", decimal: "paisas" },
      { name: "AED", title: "UAE dirhams", decimal: "fils" },
      { name: "JOD", title: "Jordanian dinars", decimal: "qirshs" },
    ];

    const paymentMethodsReferencesTypes = [
      { title: "Text", name: "text" },
      { title: "Number", name: "number" },
    ];

    const vehicleTypes = [
      { title: "Bus", name: "bus" },
      { title: "Car", name: "car" },
    ];

    const finesReimbursementsStatus = [
      {
        title: "Pending initial review",
        name: "pending_initial_review",
        param: "status",
      },
      {
        title: "Pending final review",
        name: "pending_final_review",
        param: "status",
      },
      { title: "Approved", name: "approved", param: "status" },
      { title: "Rejected", name: "rejected", param: "status" },
    ];

    const availableCityLanguages = [
      { name: "English", code: "en", direction: "ltr" },
      { name: "Arabic", code: "ar", direction: "rtl" },
      { name: "Urdu", code: "ur", direction: "rtl" },
      { name: "Portuguese", code: "pt", direction: "ltr" },
      { name: "Spanish", code: "es", direction: "ltr" },
      { name: "Swahili", code: "sw", direction: "ltr" },
      { name: "Spanish (Argentina)", code: "es-AR", direction: "ltr" },
      { name: "Portuguese (Brazil)", code: "pt-BR", direction: "ltr" },
    ];
    const requiredCityLanguages = [
      { name: "English", code: "en", direction: "ltr", isReuired: true },
    ];

    const officeDirection = [
      { title: "To Office", name: "to_office" },
      { title: "From Office", name: "from_office" },
    ];

    const corporateContractStatus = [
      { title: "Pending", name: "pending", param: "status" },
      { title: "Approved", name: "approved", param: "status" },
      { title: "Rejected", name: "rejected", param: "status" },
      { title: "Any", name: null, param: "status" },
    ];

    const supplyCategoryList = [
      { title: "Captain only", name: null, param: "supply_category" },
      { title: "Contractor", name: "contractor", param: "supply_category" },
      { title: "Company", name: "company", param: "supply_category" },
    ];

    const taxFilers = [
      { title: "Filer", name: true },
      { title: "Non Filer", name: false },
      { title: "None", name: null },
    ];

    this.all = {
      active,
      dispatch,
      tier,
      captainStatus,
      bookingStatus,
      cashCollectionStatus,
      rideStatus,
      backupStatus,
      backupStationStatus,
      shiftStatus,
      payments,
      captainPayments,
      captainLoans,
      states,
      ticketTitles,
      reportTypes,
      weekDays,
      paymentOptions,
      invoiceStatus,
      invoicePaid,
      planWeekDays,
      dayOptions,
      cancellationRulesTimeOptions,
      cancellationRulesAnchorOptions,
      rideTypes,
      supportedRideTypes,
      corpRoles,
      arrivedFirstStation,
      hasBookings,
      unassignedCaptain,
      unassignedVendor,
      dailyReportKeys,
      stationsHeatmapTime,
      stationsHeatmapLocation,
      eventStationsTypes,
      stationsHeatmapSource,
      stationsHeatmapDemand,
      generateReportTypes,
      routeSatisfictionTypes,
      routeTimingTypes,
      routeType,
      promoSegments,
      renewalValues,
      initialRenewalValues,
      resolvedTravelRequest,
      fromTravelCities,
      toTravelCities,
      scheduleLabels,
      scheduleLabelsWithNone,
      privateBusStatus,
      isRoundTrip,
      isPrivateBusReq,
      packageDiscountTypes,
      bulkBonusesCategories,
      bulkScriptsCategories,
      corporateInvoiceItemType,
      packageUserSubscribed,
      currencyList,
      rideType,
      supportedPackageTypes,
      roundingOffList,
      paymentMethodsReferencesTypes,
      vehicleTypes,
      finesReimbursementsStatus,
      availableCityLanguages,
      requiredCityLanguages,
      officeDirection,
      corporateContractStatus,
      distanceTypes,
      supplyCategoryList,
      taxFilers,
    };
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/services/lists/lists.service.js